import store from "@invesco/shared/store/index";
import analytics from "@react-native-firebase/analytics";
import * as Application from "expo-application";
import Constants from "expo-constants";
import { Platform } from "react-native";

const isNative = Platform.OS === "android" || Platform.OS === "ios";

function getCommonParams() {
  const state = (store?.getState?.() as any) || ({} as any);
  const pan = state?.user?.pan || "-";
  const app_version =
    Constants.expoConfig?.version ?? Application.nativeApplicationVersion ?? "0.0.0";
  const platform = Platform.OS;
  return { pan, app_version, platform };
}

export const Analytics = {
  async logEvent(
    name: "API_ERROR" | "MOBILE_CTA" | "WEB_CTA",
    params?: Record<string, any>,
  ) {
    if (!isNative) return;
    try {
      const common = getCommonParams();
      if (common.pan && common.pan !== "unknown") {
        await analytics().setUserId(String(common.pan));
        // console.log("[Analytics] User ID set:", common.pan);
      }
      await analytics().logEvent(name, { ...common, ...params });
      // console.log("[Analytics] Event logged:", name, { ...common, ...params });
    } catch (error) {
      console.error("[Analytics] Error logging event:", error);
    }
  },

  async logScreenView(screenName: string, screenClass?: string) {
    if (!isNative) return;
    try {
      const common = getCommonParams();
      if (common.pan && common.pan !== "unknown") {
        await analytics().setUserId(String(common.pan));
        // console.log("[Analytics] User ID set:", common.pan);
      }
      await analytics().logScreenView({
        screen_name: screenName,
        screen_class: screenClass || screenName,
      });
      // console.log("[Analytics] Screen view logged:", {
      //   screen_name: screenName,
      //   screen_class: screenClass || screenName,
      // });
    } catch (error) {
      console.error("[Analytics] Error logging screen view:", error);
    }
  },

  async logPurchase(
    transactionId: string,
    amount: number,
    currency: string = "INR",
    fundName?: string,
    schemeName?: string,
  ) {
    if (!isNative) return;
    try {
      const common = getCommonParams();
      if (common.pan && common.pan !== "unknown") {
        await analytics().setUserId(String(common.pan));
        // console.log("[Analytics] User ID set:", common.pan);
      }
      await analytics().logPurchase({
        transaction_id: transactionId,
        value: amount,
        currency: currency,
        items: [
          {
            item_id: fundName || "-",
            item_name: schemeName || "-",
            price: amount,
          },
        ],
        ...common,
      });
      // console.log("[Analytics] Purchase logged:", {
      //   transaction_id: transactionId,
      //   value: amount,
      //   currency: currency,
      //   items: [
      //     {
      //       item_id: fundName || "-",
      //       item_name: schemeName || "-",
      //       price: amount,
      //     },
      //   ],
      //   ...common,
      // });
    } catch (error) {
      console.error("[Analytics] Error logging purchase:", error);
    }
  },
};
